export type SupportedLocale = "en" | "fr";

const FR_PREFIX = "/fr/app";
const EN_PREFIX = "/app";

export function detectLocaleFromURL(): SupportedLocale {
	return window.location.pathname.startsWith(FR_PREFIX) ? "fr" : "en";
}

export function getBasename(locale: SupportedLocale): string {
	return locale === "fr" ? FR_PREFIX : EN_PREFIX;
}

export function getAppPrefix(locale: SupportedLocale): string {
	return locale === "fr" ? FR_PREFIX : EN_PREFIX;
}

export function switchLocaleURL(targetLocale: SupportedLocale): string {
	const { pathname, search, hash } = window.location;
	const currentPrefix = pathname.startsWith(FR_PREFIX) ? FR_PREFIX : EN_PREFIX;
	const rest = pathname.slice(currentPrefix.length);
	const newPrefix = getAppPrefix(targetLocale);
	return newPrefix + rest + search + hash;
}
